<header class="create__top-bar">
	<div class="space-y-2">
		<app-matter-type-icon [fileType]="fileType" />
		<h5 class="h5 text-gray-700">{{ fileType | titlecase }} #{{ number }}</h5>
		<h5 class="h5 text-gray-700">{{ name }}</h5>
	</div>

	<app-step-progress-nav
		[steps]="steps"
		[current]="state"
		class="max-w-2xl"
		[clickable]="true"
		(stepClicked)="stepClicked($event)"
		[testHook]="testHooks.StepProgressNav"
	></app-step-progress-nav>
	<div class="flex p-2 items-center right-10 mt-3">
		<app-sale-to-nav-notes class="ml-5"></app-sale-to-nav-notes>
	</div>
</header>

<router-outlet class="hidden-router"></router-outlet>

<footer class="create__bottom-bar">
	<ui-button
		(click)="back()"
		[preset]="BUTTON_PRESETS.EXTRA_LOW_EMPHASIS"
		class="self-end"
		[@fade]
		*ngIf="state !== states.APS"
		[testHook]="testHooks.BackButton"
		label="Back"
	>
	</ui-button>
	<div class="flex gap-5 ml-auto">
		<ui-button
			*ngIf="showSkip$ | async"
			[preset]="BUTTON_PRESETS.EXTRA_LOW_EMPHASIS"
			(click)="skip()"
			[testHook]="testHooks.SkipButton"
			label="Skip"
		></ui-button>
		<ui-button
			(click)="continue()"
			[preset]="BUTTON_PRESETS.HIGH_EMPHASIS"
			[testHook]="testHooks.ContinueButton"
			label="Continue"
		></ui-button>
	</div>
</footer>
